import React, {FC} from 'react'
import MainAsideMenuLayout from "@layouts/mainAsideMenuLayout/MainAsideMenuLayout";


const UserPage: FC<any> = (props) => {

  let {} = props

  return (
    <MainAsideMenuLayout>
      {/*<BackLinkLayout>*/}
      <div>User
      </div>
      {/*</BackLinkLayout>*/}
    </MainAsideMenuLayout>
  )
}

export default UserPage;